module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a-entity', {
    attrs: {
      "id": "camera",
      "camera": "",
      "position": _vm.attributify(_vm.position),
      "look-controls": _vm.controlsEnabled ? '' : 'enabled: false; hmdEnabled: false;'
    }
  }, [_c('end-message')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f769ba48!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Camera.vue
// module id = 190
// module chunks = 2